import { styled, Button } from '@mui/material';

const PrimaryButton = styled(Button)(() => ({
  background: '#956a2d',
  color: '#fff',
  fontWeight: 600,
  borderRadius: 8,
  padding: '10px 24px',
  fontSize: '1.1em',
  boxShadow: 'none',
  fontFamily: "'Libre Franklin', sans-serif",
  '&:hover': {
    opacity: 0.9,
    background: '#956a2d',
  },
  '&.Mui-disabled': {
    color: '#fff',
  },
}));

export default PrimaryButton; 
